<template>
  <!-- Decorative status cards showing the kind of work the systems do -->
  <ul class="hero-cards" aria-hidden="true">
    <li class="hero-card hero-card-sync">
      <span class="hc-icon hc-teal">
        <svg viewBox="0 0 24 24"><path d="M5 12.5l4.2 4.2L19 7" /></svg>
      </span>
      <span class="hc-text"><strong>Orders synced to invoices</strong>Just now</span>
    </li>
    <li class="hero-card hero-card-alert">
      <span class="hc-icon hc-apricot">
        <svg viewBox="0 0 24 24">
          <path d="M20 11.5a8 8 0 0 1-11.7 7.1L4 20l1.4-4.1A8 8 0 1 1 20 11.5z" />
        </svg>
      </span>
      <span class="hc-text"><strong>WhatsApp alert sent</strong>Customer notified</span>
    </li>
    <li class="hero-card hero-card-devices">
      <span class="hc-chip">Web</span><span class="hc-chip">iOS</span
      ><span class="hc-chip">Android</span>
    </li>
  </ul>
</template>

<script>
export default { name: "HeroCards" };
</script>
